var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBalaoErro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icone_Erro",
    "data-name": "Icone Erro",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.225,
    height: 59.225,
    viewBox: "0 0 59.225 59.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2166",
    "data-name": "Caminho 2166",
    d: "M29.612,0A29.612,29.612,0,1,1,0,29.612,29.612,29.612,0,0,1,29.612,0Z",
    fill: "#f2453d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_15",
    "data-name": "Uni\\xE3o 15",
    d: "M10.911,10.911,0,21.821,10.911,10.911,0,0,10.911,10.911,21.821,0,10.911,10.911,21.821,21.821Z",
    transform: "translate(18.5 18.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalaoErro);
export default __webpack_public_path__ + "static/media/balao-erro.305ea6e73a4da68096041838fefa7e71.svg";
export { ForwardRef as ReactComponent };